import type { ReactNode } from "react";
import { FormFieldLabelRow, useFormFieldLabelAccessory } from "@patient-watch/ui/form";

/** Renders a form label, with an optional trailing accessory from context or prop. */
export function FormFieldLabelWithAccessory({ label, labelTrailing }: { label: ReactNode; labelTrailing?: ReactNode }) {
    const contextAccessory = useFormFieldLabelAccessory();
    const trailing = labelTrailing ?? contextAccessory;
    return <FormFieldLabelRow label={label} trailing={trailing ?? undefined} />;
}
